import { Button } from '@/components/ui/button'

export const HeroSection = () => {
  // Use a constant for the background image to ensure consistency across devices
  const backgroundImage =
    "url('https://img.usecurling.com/p/1920/1080?q=sensual%20lingerie%20woman&color=black')"

  return (
    <section className="relative w-full min-h-[90vh] lg:min-h-screen flex items-center overflow-hidden bg-black py-12 md:py-20 lg:py-0">
      {/* Background Image Layer - Standardized for all devices */}
      <div
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: backgroundImage,
        }}
      />

      {/* Overlay Layers for Readability */}
      {/* Base dimming layer - Standardized opacity */}
      <div className="absolute inset-0 z-0 bg-black/50 pointer-events-none" />

      {/* Horizontal gradient to ensure text readability on the left */}
      <div className="absolute inset-0 z-0 bg-gradient-to-r from-black/90 via-black/60 to-transparent pointer-events-none" />

      {/* Bottom gradient for smooth transition */}
      <div className="absolute bottom-0 left-0 right-0 z-0 h-40 bg-gradient-to-t from-black to-transparent pointer-events-none" />

      {/* Content Container */}
      <div className="container mx-auto px-4 sm:px-6 md:px-12 relative z-10">
        <div className="flex flex-col items-center lg:items-start text-center lg:text-left max-w-3xl">
          {/* Scarcity Badge */}
          <div className="bg-accent/10 border border-accent/20 text-accent text-[10px] sm:text-xs font-bold rounded-full px-3 py-1.5 mb-6 shadow-[0_0_15px_rgba(255,215,0,0.15)] animate-fade-in-up inline-flex items-center gap-2 uppercase tracking-wide backdrop-blur-md">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-accent"></span>
            </span>
            Vagas Extremamente Limitadas
          </div>

          {/* Sub-headline */}
          <p
            className="font-heading font-bold text-sm sm:text-base md:text-xl text-primary mb-4 uppercase tracking-wider animate-fade-in-up opacity-0"
            style={{ animationDelay: '100ms' }}
          >
            Pare de sonhar. Comece a viver.
          </p>

          {/* Main Title */}
          <h1
            className="font-heading font-black text-3xl sm:text-4xl md:text-5xl lg:text-7xl text-white leading-[1.1] mb-6 uppercase text-balance animate-fade-in-up opacity-0 tracking-tight drop-shadow-2xl"
            style={{ animationDelay: '200ms' }}
          >
            Domine o mercado de{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-accent">
              conteúdo adulto
            </span>
          </h1>

          {/* Value Proposition */}
          <div
            className="font-sans font-medium text-base sm:text-lg text-gray-200 mb-8 max-w-xl leading-relaxed animate-fade-in-up opacity-0 text-balance space-y-3 drop-shadow-md"
            style={{ animationDelay: '300ms' }}
          >
            <p className="text-white font-bold text-xl sm:text-2xl">
              Fature de $100k a $500k/mês.
            </p>
            <p>
              Lucas de Alencar entrega o mapa exato para dominar o OFM, sem
              aparecer e sem investimento inicial. Construa seu império agora.
            </p>
          </div>

          {/* CTA Button */}
          <Button
            asChild
            className="bg-primary hover:bg-primary/90 text-white font-heading font-bold text-lg h-14 px-10 rounded-xl shadow-[0_8px_24px_rgba(255,107,0,0.4)] w-full sm:w-auto transition-all duration-300 hover:scale-105 hover:shadow-[0_12px_32px_rgba(255,107,0,0.6)] animate-fade-in-up opacity-0 uppercase tracking-wide group"
            style={{ animationDelay: '400ms' }}
          >
            <a
              href="https://wa.me/558393917008?text=Fala%20Lucas%2C%20gostaria%20de%20saber%20mais%20sobre%20a%20mentoria%20OFM%20ELITE%21"
              target="_blank"
              rel="noopener noreferrer"
            >
              Garantir Minha Vaga
            </a>
          </Button>
        </div>
      </div>
    </section>
  )
}
